export const forums = {
  forumsSearchInputPlaceholder: 'Hledat',
  forumsFollowDiscussionButtonTitle: 'Sledovat',
  forumsFollowingDiscussButtonTitle: 'Sledováno',
  forumDiscussionInfoNoReplyText: 'Zatím žádné odpovědi',
  forumsDiscussionDetailsStartButtonTitle: 'Začít diskuzi',
  forumDetailsCreatedByText: 'od',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Kopírovat odkaz',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Nahlásit obsah',
  forumsReportedCurtainContent: 'Obsah nahlášen',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Odkaz zkopírován!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Připnout diskuzi',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Odepnout diskuzi',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Upravit diskuzi',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Smazat diskuzi',
  forumsDiscussionDetailspPopupDeleteTitle: 'Smazat',
  forumsDiscussionDetailspPopupDeleteText: 'Smazat tuto diskuzi?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Zrušit',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Potvrdit',
  forumsDiscussionDetailsDeleledAlertText: 'Diskuze smazána!',
  forumsNewDiscussionTitle: 'Nová diskuse',
  forumsNewDiscussionTitlePlaceholder: 'Název...',
  forumsNewDiscussionBodyPlaceholderText: 'Vložte text zde...',
  forumsNewDiscussionPublishButtonTitle: 'Publikovat',
  forumsNewDiscussionLocationCurtainTitle: 'Lokace',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Název lokace',
  forumsNewDiscussionEditLocationCurtainText: 'Upravit lokaci',
  forumsNewDiscussionDeleteLocationCurtainText: 'Smazat lokaci',
  forumsNewDiscussionCreatePollTitle: 'Vytvořit hlasování',
  forumsNewDiscussionTitleInputPlaceholder: 'Název',
  forumsNewDiscussionOptionInputPlaceholder: 'Možnost',
  forumsNewDiscussionAddButtonTitle: 'Přidat možnost',
  forumsNewDiscussionCreateButtonTitle: 'Vytvořit',
  forumsNewDiscussionPollTitleBlankAlertText: 'Název nesmí být prázdný!',
  forumsNewDiscussionPollOptionBlankAlertText: 'Možnost nesmí být prázdná!',
  forumsNewDiscussionPollLongTitleAlertText: 'Název by měl obsahovat maximálně 140 znaků',
  forumsNewDiscussionPollLongOptionAlertText: 'Možnost by měla obsahovat maximálně 25 znaků',
  forumsNewDiscussionEditPollIconText: 'Upravit hlasování',
  forumsNewDiscussionRemovePollIconText: 'Odstranit hlasování',
  forumsDiscardDraftPopupTitle: 'Návrh',
  forumsDiscardDraftPopupText: 'Zahodit tento návrh?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Zrušit',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Potvrdit',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Odpovědět',
  forumsDiscussionDetailsNoCommentsText: 'Zatím zde nejsou žádné komentáře\nMůžete být první, kdo něco napíše',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Odpovědět',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Kopírovat odkaz',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Odkaz zkopírován!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Nahlásit obsah',
  forumsDiscussionDetailsPostCurtainReportedText: 'Obsah nahlášen',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Odpovědět',
  forumsEditDiscussionTitle: 'Upravit diskuzi',
  forumsEditDiscussionSaveButtonTitle: 'Uložit',
  forumsEditedDiscussionSavedAlertText: 'Diskuze uložena!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Upravit odpověď',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Smazat odpověď',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Komentář uložen!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Komentář smazán!',
  forumsAlertSomethinWrong: 'Něco se pokazilo!',
  forumsMaxMbSize: 'Můžete nahrát maximálně {size} MB najednou',
  forumsMaxAttachments: 'Překročili jste maximální počet příloh. Maximální počet příloh je {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Smazat',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Smazat tento komentář?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Zrušit',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Potvrdit',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Nahlásit obsah',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Obsah nahlášen',
  forumDiscussionInfoLastReplyText: 'Poslední odpověď',
  forumsDiscussionAt: 'v',
  forumsDiscussionDetailsFlagCurtainTitle: 'Nahlásit',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Obsah nahlášen',
  forumsPollInfoVotesText: 'hlasy',
  forumsPollInfoEditVoteText: 'Upravit hlas',
  forumsPollFinishPollText: 'Ukončit hlasování',
  forumsPollFinishedPollText: 'Dokončeno',
  forumsPollInProgresslText: 'Probíhá',
  forumsPollCurtainTitle: 'Ukončit hlasování',
  forumsPollCurtainText: 'Uživatelé nebudou moci hlasovat poté, co hlasování skončí.',
  forumsFinishPollCurtainCancelButtonTitle: 'Zrušit',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Potvrdit',
  forumsPollInfoPollVotesCurtainTitle: 'Hlasování'
}
